import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationIntegrationAppResource from './OrganizationIntegrationAppResource';
import ConnectorConfigAppResource from "./ConnectorConfigAppResource";

export const CONNECTOR_SLUGS = {
    MOXI: 'moxi',
    SKYSLOPE: 'skyslope',
    TOTALEXPERT: 'totalexpert',
    FOLLOW_UP_BOSS: 'followupboss',
};

class ConnectorAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'connector';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'connectors';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'created_at',
            'updated_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'uuid',
            'name',
            'description',
            'slug',
            'logo',
            'isEnabled',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            config: ConnectorConfigAppResource,
            integrations: OrganizationIntegrationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [];
    }

}

export default ConnectorAppResource;
